import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

import { CreateEmploymentHistory } from "../Types/Employee/EmploymentHistory";

export const EMPLOYEE_TIMELINE_QUERY_KEY = ["employment-history"];
export const VIEW_EMPTIMELINE_QUERY_KEY = ["view-employment-history"];

export const employmentHistoryService = {
  createEmploymentHistory: (payload: CreateEmploymentHistory) =>
    requestWithRefresh(() =>
      api
        .post("api/employment-history", payload, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),

  toggleStatus: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(
        `api/employment-history/${id}/toggle-status`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data;
    });
  },

  ViewEmploymentHistory: async (emp_no: string) => {
    const response = await api.get(`api/view-employment-history/${emp_no}`);
    return response.data.data;
  },
};
